export default "__VITE_ASSET__BoJT0i5r__"